import React, { useContext,useState, useEffect } from "react";
import {
  Checkbox,
  Dropdown,
  Icon,
  PrimaryButton,
  Stack,
  TextField,
  Calendar,
  TooltipHost,
  SearchBox,
} from "@fluentui/react";
import themeContext from "../../../../../context/theme/ThemeContext";
import studylistContext from "../../../../../context/studylist/StudylistContext";
import { isMobile } from "react-device-detect";
import { t } from "i18next";
import { CancelIcon } from "@fluentui/react-icons-mdl2";
import ClearIcon from "../../../../../components/SVGComponents/ClearIcon";
import userContext from "../../../../../context/users/UserContext";
import { REPORTED_SUBTABS_ID, USERTYPES } from "../../../../../constants/Constants";
import { getEnv } from '../../../../../helpers/EnvHelper';
import { T } from "@kitware/vtk.js/macros2";

const SearchFilter = (props) => {
  const {
    setAllStudies,
    studyData,
    columns,
    allStudies,
    searchDto,
    setSearchDto,
    patientNameBadgeShow,
    removeBadgeFromFilter,
    setPatientDetail,
    setOrderId,
    setAccessionNumber,
    setKeyword,
    setStudyDescription,
    selectedValue,
    handleEnterKeyPress,
    setFilterClicked,
    setApplyButtonEnabled,
    setPagination,
    setPatientNameBadgeShow,
    setFilterApplied,
    filterApplied,
    handleChangeSizeIndex
  } = useContext(studylistContext);

  const { themeName,getThemeColor } = useContext(themeContext);
  const [searchBy, setSearchBy] = useState(getEnv("REACT_APP_VDC_PLATFORM") == "true"?2:1); //1 for patient name or id and 2 for order id 3 for accession number
  const { roles } = useContext(userContext);
  const searchIcon = {
    iconName: "search",
    cursor: "pointer",
    style: {
      color:
        themeName == "dark" || themeName == "dark-midnight"
          ? "rgba(172, 172, 172, 0.75)"
          : "",
    },
  };

  const searchInputStyle = {
    root: {
      width: isMobile?"100%":"190px",
    },
    field: {
      paddingRight:'28px',
    }
    
  };
  const searchInputStyle2 = {
    root: {
      width: isMobile?"100%":"175px",
    },
    field: {
      backgroundColor: themeName === "light"? '' : '#000',  

    }
    
  };

  const resetKeywordStateFun = () => {
    
    if(searchBy == 4){
      getEnv("REACT_APP_VDC_PLATFORM") == "true" ?setSearchBy(2):setSearchBy(1);
    }
    setKeyword(null);
    removeBadgeFromFilter({ key: "keyword" });
  };
  
  useEffect(() => {
    if (!REPORTED_SUBTABS_ID.includes(selectedValue)) {
      resetKeywordStateFun();
    }
  }, [selectedValue]); 
  
  const patientIdorOrderIdBasedSearch = () => {
   
    if(searchBy ==1 && searchDto.patientNameOrId != null &&
      searchDto.patientNameOrId.length > 0){
        
        handleChangeSizeIndex(0,50,"");
        setPatientNameBadgeShow(true);
        let searchTrimmedData = searchDto.patientNameOrId.trim();
        setSearchDto({...searchDto, patientNameOrId:searchTrimmedData })
        setSearchDto({...searchDto, orderId:null })
        setSearchDto({...searchDto, accessionNumber:null })
        setSearchDto({...searchDto, keyword:null })
        setSearchDto({...searchDto, studyDescription:null })
        let filterUpdated = filterApplied + 1;
        setFilterApplied(filterUpdated);

      }else if(searchBy == 2 && searchDto.orderId != null &&
        searchDto.orderId.length > 0){
          
          handleChangeSizeIndex(0,50,"");
          setPatientNameBadgeShow(true);
          let searchTrimmedData = searchDto.orderId.trim();
          setSearchDto({...searchDto, orderId:searchTrimmedData })
          setSearchDto({...searchDto, patientNameOrId:null })
          setSearchDto({...searchDto, accessionNumber:null })
          setSearchDto({...searchDto, keyword:null })
          setSearchDto({...searchDto, studyDescription:null })
          let filterUpdated = filterApplied + 1;
          setFilterApplied(filterUpdated);
        }
        else if(searchBy == 3 && searchDto.accessionNumber != null &&
          searchDto.accessionNumber.length > 0){
  
            handleChangeSizeIndex(0,50,"");
            setPatientNameBadgeShow(true);
            let searchTrimmedData = searchDto.accessionNumber.trim();
            setSearchDto({...searchDto, accessionNumber:searchTrimmedData })
            setSearchDto({...searchDto, patientNameOrId:null })
            setSearchDto({...searchDto, orderId:null })
            setSearchDto({...searchDto, keyword:null })
            setSearchDto({...searchDto, studyDescription:null })
            let filterUpdated = filterApplied + 1;
            setFilterApplied(filterUpdated);
          }
          else if(searchBy == 4 && searchDto.keyword != null &&
            searchDto.keyword.length > 0){
    
              handleChangeSizeIndex(0,50,"");
              setPatientNameBadgeShow(true);
              let searchTrimmedData = searchDto.keyword.trim();
              setSearchDto({...searchDto, accessionNumber:null })
              setSearchDto({...searchDto, patientNameOrId:null })
              setSearchDto({...searchDto, orderId:null })
              setSearchDto({...searchDto, keyword:searchTrimmedData })
              setSearchDto({...searchDto, studyDescription:null })
              let filterUpdated = filterApplied + 1;
              setFilterApplied(filterUpdated);
            }
            else if(searchBy == 5 && searchDto.studyDescription != null &&
              searchDto.studyDescription.length > 0){

                handleChangeSizeIndex(0,50,"");
                setPatientNameBadgeShow(true);
                let searchTrimmedData = searchDto.studyDescription.trim();
                setSearchDto({...searchDto, studyDescription:searchTrimmedData })
                setSearchDto({...searchDto, patientNameOrId:null })
                setSearchDto({...searchDto, orderId:null })
                setSearchDto({...searchDto, accessionNumber:null })
                setSearchDto({...searchDto, keyword:null })
                let filterUpdated = filterApplied + 1;
                setFilterApplied(filterUpdated);
              }
  }


  return (
    <>
      <div
        style={{
          display: isMobile?"flex":"flex",
          alignItems: "center",
          gap: "6px",
          marginRight: isMobile?"10px":"unset"         
        }}
      >


        {getEnv("REACT_APP_VDC_PLATFORM") == "true" && <div style={{ display: "flex"}}>
            <TooltipHost content="Patient Name or ID">
            <PrimaryButton
             className="force-no-border-right-radius"
              onClick={() => {
                setOrderId(null);
                setAccessionNumber(null);
                setKeyword(null);
                setStudyDescription(null);
                setSearchBy(1);
                removeBadgeFromFilter({ key: "orderId" });
                removeBadgeFromFilter({ key: "keyword" });
                removeBadgeFromFilter({ key: "studyDescription" });
              }}
              text="Patient Name or ID"
              style={{
                fontSize: "12px",
                fontWeight: "400",
                padding: "0px 3px",
                whiteSpace: "nowrap",
                borderTopLeftRadius: "30px",
                borderBottomLeftRadius: "30px",
                zIndex: searchBy !== 1 ? "" : "100",
                //background: searchBy !== 1 ? "black" : "",
                //color:"white",
                background: searchBy === 1 ? "#0078d4" : getThemeColor("search-filter-bgm-nonactive"),
                color: searchBy === 1 ? "white" : getThemeColor("search-filter-nonactive"),
                outline: "white",
                borderTopRightRadius: searchBy == 1 ? "0px" : "",
                borderBottomRightRadius: searchBy == 1 ? "0px" : "",
                paddingRight: "0px",
                //color:"white"
              }}
            />
            </TooltipHost>

            <TooltipHost content="Order ID">
            <PrimaryButton

              className={`${(REPORTED_SUBTABS_ID.includes(selectedValue) && 
              (roles[0] === USERTYPES.SUPERVISOR || roles[0] === USERTYPES.FIRMADMIN)) 
              ? "force-no-border-radius" 
              : [USERTYPES.FIRMADMIN, USERTYPES.SUPERVISOR, USERTYPES.FIRMTECHNICIAN, USERTYPES.FIRMDOCTOR, USERTYPES.RADIOLOGIST,USERTYPES.TYPIST].includes(roles[0])
              ? "force-no-border-radius"
              : "force-no-border-left-radius"}`}
              onClick={() => {
                setPatientDetail(null);
                setKeyword(null);
                setStudyDescription(null);
                setSearchBy(2);
                removeBadgeFromFilter({ key: "patientName" });
                removeBadgeFromFilter({ key: "keyword" });
                removeBadgeFromFilter({ key: "studyDescription" });
               
              }}
              text="Order ID"
              style={{
                fontSize: "12px",
                fontWeight: "400",
                padding: "0px 3px",
                whiteSpace: "nowrap",
                marginLeft: "0px",
                borderTopRightRadius: (!REPORTED_SUBTABS_ID.includes(selectedValue) || 
                  ((roles[0] !== USERTYPES.RADIOLOGIST && roles[0] !== USERTYPES.SUPERVISOR && roles[0] !== USERTYPES.FIRMADMIN) && 
                   ![USERTYPES.FIRMADMIN, USERTYPES.SUPERVISOR, USERTYPES.FIRMTECHNICIAN, USERTYPES.FIRMDOCTOR].includes(roles[0]))) 
                  ? "30px" 
                  : "0px",
             
                  borderBottomRightRadius: (!REPORTED_SUBTABS_ID.includes(selectedValue) || 
                    ((roles[0] !== USERTYPES.RADIOLOGIST && roles[0] !== USERTYPES.SUPERVISOR && roles[0] !== USERTYPES.FIRMADMIN) && 
                     ![USERTYPES.FIRMADMIN, USERTYPES.SUPERVISOR, USERTYPES.FIRMTECHNICIAN, USERTYPES.FIRMDOCTOR].includes(roles[0]))) 
                    ? "30px" 
                    : "0px",
                
                paddingLeft: searchBy !== 2 ? "" : "",
                // background: searchBy !== 2 ? "black" : "",
                // color:"white",
                background: searchBy === 2 ? "#0078d4" : getThemeColor("search-filter-bgm-nonactive"),
                color: searchBy === 2 ? "white" : getThemeColor("search-filter-nonactive"),
                zIndex: searchBy !== 2 ? "" : "100",
                borderTopLeftRadius: searchBy == 2 ? "0px" : "",
                borderBottomLeftRadius: searchBy == 2 ? "0px" : "",
                //color:"white"
              }}
            />
            </TooltipHost>
          {[USERTYPES.FIRMADMIN, USERTYPES.SUPERVISOR, USERTYPES.FIRMTECHNICIAN, USERTYPES.FIRMDOCTOR, USERTYPES.RADIOLOGIST, USERTYPES.TYPIST].includes(roles[0]) &&
            <TooltipHost content="Study Description">
            <PrimaryButton
             className={(REPORTED_SUBTABS_ID.includes(selectedValue) && (roles[0] == USERTYPES.RADIOLOGIST || roles[0] == USERTYPES.SUPERVISOR || roles[0] == USERTYPES.FIRMADMIN)) ? "force-no-border-radius" : "force-no-border-left-radius"}
              onClick={() => {
                setPatientDetail(null);
                setAccessionNumber(null);
                setKeyword(null);
                setSearchBy(5);
                removeBadgeFromFilter({ key: "patientName" })
                removeBadgeFromFilter({ key: "orderId" })
                removeBadgeFromFilter({ key: "accessionNumber" })
              }}
              text="Study Desc."
              style={{
                fontSize: "12px",
                fontWeight: "400",
                padding: "0px 3px",
                whiteSpace: "nowrap",
                marginLeft: "0px",
                background: searchBy === 5 ? "#0078d4" : getThemeColor("search-filter-bgm-nonactive"),
                color: searchBy === 5 ? "white" : getThemeColor("search-filter-nonactive"),
                zIndex: searchBy !== 5 ? "" : "100",
                borderTopRightRadius: "30px",
                borderBottomRightRadius: "30px",
                borderTopLeftRadius: searchBy == 5 ? "0px" : "",
                borderBottomLeftRadius: searchBy == 5 ? "0px" : "",
              }}
            />
            </TooltipHost>
            }
          {(REPORTED_SUBTABS_ID.includes(selectedValue) && (roles[0] == USERTYPES.RADIOLOGIST || roles[0] == USERTYPES.SUPERVISOR
            || roles[0] == USERTYPES.FIRMADMIN
          )) &&
            <TooltipHost content="Keyword">
            <PrimaryButton
             className="force-no-border-left-radius"
              onClick={() => {
                setPatientDetail(null);
                setAccessionNumber(null);
                setSearchBy(4);
                removeBadgeFromFilter({ key: "patientName" })
                removeBadgeFromFilter({ key: "orderId" })
                removeBadgeFromFilter({ key: "studyDescription" })
              }}
              text="Keyword"
              style={{
                fontSize: "12px",
                fontWeight: "400",
                padding: "0px 3px",
                whiteSpace: "nowrap",
                marginLeft: "0px",
                borderTopRightRadius: "30px",
                borderBottomRightRadius: "30px",
                background: searchBy === 4 ? "#0078d4" : getThemeColor("search-filter-bgm-nonactive"),
                color: searchBy === 4 ? "white" : getThemeColor("search-filter-nonactive"),
                zIndex: searchBy !== 4 ? "" : "100",
                borderTopLeftRadius: searchBy == 4 ? "0px" : "",
                borderBottomLeftRadius: searchBy == 4 ? "0px" : "",
                //color:"white"
              }}
            />
            </TooltipHost>
            }
          </div>

          
        }
        {getEnv("REACT_APP_VDC_PLATFORM") == "false" && roles[0] !== USERTYPES.ADMIN 
        && <div style={{ display: "flex", margin:"0px 7px" }}>
            <TooltipHost content="Patient Name or ID">
            <PrimaryButton
             className="force-no-border-right-radius"
              onClick={() => {
                setOrderId(null);
                setAccessionNumber(null);
                setKeyword(null);
                setStudyDescription(null);
                setSearchBy(1);
                removeBadgeFromFilter({ key: "accessionNumber" });
                removeBadgeFromFilter({ key: "studyDescription" });
              }}
              text="Patient Name or ID"
              style={{
                   fontSize: "12px",
                fontWeight: "400",
                padding: "0px 3px",
                whiteSpace: "nowrap",
                borderTopLeftRadius: "30px",
                borderBottomLeftRadius: "30px",
                zIndex: searchBy !== 1 ? "" : "100",
                // background: searchBy !== 1 ? "black" : "",
                // color:"white",
                background: searchBy === 1 ? "#0078d4" : getThemeColor("search-filter-bgm-nonactive"),
                color: searchBy === 1 ? "white" : getThemeColor("search-filter-nonactive"),
                outline: "white",
                borderTopRightRadius: searchBy == 1 ? "0px" : "",
                borderBottomRightRadius: searchBy == 1 ? "0px" : "",
                paddingRight: "0px",
                //color:"white"
              }}
            />
            </TooltipHost>
            {roles[0] !== USERTYPES.TYPIST && (
            <TooltipHost content="Accession Number">
            <PrimaryButton
             className={`${(REPORTED_SUBTABS_ID.includes(selectedValue) && 
              (roles[0] == USERTYPES.RADIOLOGIST || roles[0] === USERTYPES.SUPERVISOR || roles[0] === USERTYPES.FIRMADMIN)) 
              ? "force-no-border-radius" 
              : [USERTYPES.FIRMADMIN, USERTYPES.SUPERVISOR, USERTYPES.FIRMTECHNICIAN, USERTYPES.FIRMDOCTOR, USERTYPES.RADIOLOGIST, USERTYPES.TYPIST].includes(roles[0])
              ? "force-no-border-radius"
              : "force-no-border-left-radius"}`}
              onClick={() => {
                setPatientDetail(null);
                setKeyword(null);
                setStudyDescription(null);
                setSearchBy(3);
                removeBadgeFromFilter({ key: "patientName" })
                removeBadgeFromFilter({ key: "studyDescription" })
              }}
              text="Accession Num"
              style={{
                fontSize: "12px",
                fontWeight: "400",
                padding: "0px 3px",
                whiteSpace: "nowrap",
                marginLeft: "0px",
                borderTopRightRadius: (!REPORTED_SUBTABS_ID.includes(selectedValue) || 
                  ((roles[0] !== USERTYPES.RADIOLOGIST && roles[0] !== USERTYPES.SUPERVISOR && roles[0] !== USERTYPES.FIRMADMIN) && 
                   ![USERTYPES.FIRMADMIN, USERTYPES.SUPERVISOR, USERTYPES.FIRMTECHNICIAN, USERTYPES.FIRMDOCTOR].includes(roles[0]))) 
                  ? "30px" 
                  : "0px",
              
                  borderBottomRightRadius: (!REPORTED_SUBTABS_ID.includes(selectedValue) || 
                    ((roles[0] !== USERTYPES.RADIOLOGIST && roles[0] !== USERTYPES.SUPERVISOR && roles[0] !== USERTYPES.FIRMADMIN) && 
                     ![USERTYPES.FIRMADMIN, USERTYPES.SUPERVISOR, USERTYPES.FIRMTECHNICIAN, USERTYPES.FIRMDOCTOR].includes(roles[0]))) 
                    ? "30px" 
                    : "0px",
                
                paddingLeft: searchBy !== 3 ? "" : "",
                // background: searchBy !== 3 ? "black" : "",
                // color:"white",
                background: searchBy === 3 ? "#0078d4" : getThemeColor("search-filter-bgm-nonactive"),
                color: searchBy === 3 ? "white" : getThemeColor("search-filter-nonactive"),
                zIndex: searchBy !== 3 ? "" : "100",
                borderTopLeftRadius: searchBy == 3 ? "0px" : "",
                borderBottomLeftRadius: searchBy == 3 ? "0px" : "",
                // color:"white"
              }}
            /> 
            </TooltipHost>
            )}
            {[USERTYPES.FIRMADMIN, USERTYPES.SUPERVISOR, USERTYPES.FIRMTECHNICIAN, USERTYPES.FIRMDOCTOR, USERTYPES.RADIOLOGIST,USERTYPES.TYPIST].includes(roles[0]) &&
            <TooltipHost content="Study Description">
            <PrimaryButton

             className={(REPORTED_SUBTABS_ID.includes(selectedValue) && (roles[0] == USERTYPES.RADIOLOGIST || roles[0] == USERTYPES.SUPERVISOR || roles[0] == USERTYPES.FIRMADMIN)) ? "force-no-border-radius" : "force-no-border-left-radius"}
              
              onClick={() => {
                setPatientDetail(null);
                setAccessionNumber(null);
                setKeyword(null);
                setSearchBy(5);
                removeBadgeFromFilter({ key: "patientName" })
                removeBadgeFromFilter({ key: "orderId" })
                removeBadgeFromFilter({ key: "accessionNumber" })
              }}
              text="Study Desc."
              style={{
                fontSize: "12px",
                fontWeight: "400",
                padding: "0px 3px",
                whiteSpace: "nowrap",
                marginLeft: "0px",
                background: searchBy === 5 ? "#0078d4" : getThemeColor("search-filter-bgm-nonactive"),
                color: searchBy === 5 ? "white" : getThemeColor("search-filter-nonactive"),
                zIndex: searchBy !== 5 ? "" : "100",
                borderTopRightRadius: "30px",
                borderBottomRightRadius: "30px",
                borderTopLeftRadius: searchBy == 5 ? "0px" : "",
                borderBottomLeftRadius: searchBy == 5 ? "0px" : "",
              }}
            />
            </TooltipHost>
            }
            {(REPORTED_SUBTABS_ID.includes(selectedValue) && (roles[0] == USERTYPES.RADIOLOGIST || roles[0] == USERTYPES.SUPERVISOR
            || roles[0] == USERTYPES.FIRMADMIN
          )) &&
            <TooltipHost content="Keyword">
            <PrimaryButton

            className="force-no-border-left-radius"
              
              onClick={() => {
                setPatientDetail(null);
                setAccessionNumber(null);
                setSearchBy(4);
                removeBadgeFromFilter({ key: "patientName" })
                removeBadgeFromFilter({ key: "orderId" })
                removeBadgeFromFilter({ key: "studyDescription" })
              }}
              text="Keyword"
              style={{
                fontSize: "12px",
                fontWeight: "400",
                padding: "0px 3px",
                whiteSpace: "nowrap",
                marginLeft: "0px",
                borderTopRightRadius: "30px",
                borderBottomRightRadius: "30px",
                paddingLeft: searchBy !== 4 ? "" : "",
                background: searchBy === 4 ? "#0078d4" : getThemeColor("search-filter-bgm-nonactive"),
                color: searchBy === 4 ? "white" : getThemeColor("search-filter-nonactive"),
                zIndex: searchBy !== 4 ? "" : "100",
                borderTopLeftRadius: searchBy == 4 ? "0px" : "",
                borderBottomLeftRadius: searchBy == 4 ? "0px" : "",
                // color:"white"
              }}
            />
            </TooltipHost>
            }
          </div>
        }
        {/* {patientNameBadgeShow &&
        searchDto.patientNameOrId != null &&
        searchDto.patientNameOrId.length > 0 ? (
          <div
            className="study-list-badge-list-view"
            style={{ cursor: "pointer", width:isMobile?"fit-content":"unset" }}
            // onClick={() => setShowFilterOptions(true)}
          >
            <span className="study-list-badge-text-list-view-no-hover">
              {searchDto.patientNameOrId}
            </span>

            <Icon
              onClick={(event) => {
                event.stopPropagation();
                removeBadgeFromFilter({ key: "patientName" });
              }}
              style={{
                cursor: "pointer",
                color: "white",
                lineHeight: "2",
                marginLeft: "5px",
              }}
              iconName="Cancel"
              className="ms-fontSize-10"
            ></Icon>
          </div>
        ) : ( */}
          <>
          <span className="patient-search-input-box" style={{}}>
          <TextField
            label=""
            placeholder={
              "Search "+(
                searchBy === 2 ? t("placeholder.order-id-search") :
              searchBy === 3 ? t("placeholder.accession-number-search") :
              searchBy === 4 ? t("placeholder.keyword-based-search") :
              searchBy === 5 ? "Study Description" :
              t("placeholder.patient-search")
              )
            }
            styles={searchInputStyle2}
            name="patientName"
            value={
              searchBy === 2 ? (searchDto?.orderId ?? "") :
              searchBy === 3 ? (searchDto?.accessionNumber ?? "") :
              searchBy === 4 ? (searchDto?.keyword ?? "") :
              searchBy === 5 ? (searchDto?.studyDescription ?? "") :
              (searchDto?.patientNameOrId ?? "")
            }
            //onBlur={props.onBlur}
            onChange={(e, data) => searchBy == 2 ? setOrderId(data) : searchBy == 3 ? setAccessionNumber(data) : searchBy ==4 ? setKeyword(data) : searchBy ==5 ? setStudyDescription(data) : setPatientDetail(data)}
            //iconProps={searchIcon}
            onKeyDown={handleEnterKeyPress}
            onFocus={(e) => {props.handleSearchFocus != undefined && props.handleSearchFocus(true)}}
            onBlur={() => {props.handleSearchFocus != undefined && props.handleSearchFocus(false)}}
          />
          <span className="cancel-patient-search" 
          onClick={(event) => {
            event.stopPropagation();
            searchBy == 2 ? removeBadgeFromFilter({ key: "orderId" }) : searchBy == 3 ? removeBadgeFromFilter({ key: "accessionNumber" }) : searchBy == 4 ? removeBadgeFromFilter({ key: "keyword" }) : searchBy == 5 ? removeBadgeFromFilter({ key: "studyDescription" }) : removeBadgeFromFilter({ key: "patientName" });
          }}
          >
            {((searchDto.patientNameOrId != null && searchDto.patientNameOrId.length > 0) 
            || (searchDto.orderId != null && searchDto.orderId.length > 0) 
            || (searchDto.accessionNumber != null && searchDto.accessionNumber.length > 0)
            || (searchDto.keyword != null && searchDto.keyword.length > 0)
            || (searchDto.studyDescription != null && searchDto.studyDescription.length > 0)) 
            && <ClearIcon />}
          </span>
          </span>
          
                {/* <SearchBox
                    placeholder={t("placeholder.patient-search")}
                    styles={searchBoxInputStyle}
                    onClear={(ev) => {
                      ev.stopPropagation();
                      removeBadgeFromFilter({ key: "patientName" });
                    }}
                    value={
                      searchDto?.patientNameOrId == null
                        ? ""
                        : searchDto?.patientNameOrId
                    }
                    iconProps={{ iconName: 'Search',style:{display:'none'} }}
                    iconRenderer={(props) => {
                        return (
                        <div className={searchBoxInputStyle.iconContainer}>
                            <Icon {...props} />
                        </div>
                        );
                    }}
                    onKeyDown={(event)=>{
                      if (event.key === "Enter") {
                       console.log("--key entered ----")
                      }
                    }}
                    onChange={(e, data) => setPatientDetail(data)}
                  /> */}

            <PrimaryButton
            iconProps={{
              iconName: "Search",
              cursor: "pointer",
            }}
            onClick={() =>  patientIdorOrderIdBasedSearch() }
            text={""}
            className={!((searchDto.patientNameOrId != null && searchDto.patientNameOrId.length > 0) 
              || (searchDto.orderId != null && searchDto.orderId.length > 0)
              || (searchDto.accessionNumber != null && searchDto.accessionNumber.length > 0)
              || (searchDto.keyword != null && searchDto.keyword.length > 0)
              || (searchDto.studyDescription != null && searchDto.studyDescription.length > 0)) 
              ? "common-default-inactive-button study-list-filter-button search-active-button"
              :"common-default-active-button study-list-filter-button search-active-button"}
            styles={{root:{
                    width: "8px",
                    cursor: !((searchDto.patientNameOrId != null && searchDto.patientNameOrId.length > 0) 
                    || (searchDto.orderId != null && searchDto.orderId.length > 0)
                    || (searchDto.accessionNumber != null && searchDto.accessionNumber.length > 0)
                    || (searchDto.keyword != null && searchDto.keyword.length > 0)
                    || (searchDto.studyDescription != null && searchDto.studyDescription.length > 0)) 
                    ? "not-allowed": "pointer",
                    marginRight: "5px" 
                  }}
            }
          />

          {/* <Icon
            iconName="Search"
            className={`study-list-search-icon ${searchDto.patientNameOrId != null &&
              searchDto.patientNameOrId.length > 0 ? "study-list-search-click-allow":"study-list-search-click-not-allow"}`}
            onClick={() => {
              if(searchDto.patientNameOrId != null &&
                searchDto.patientNameOrId.length > 0){
                  setPatientNameBadgeShow(true);
                  let filterUpdated = filterApplied + 1;
                  setFilterApplied(filterUpdated);
                }
              
            }}
          ></Icon>           */}
          </>
        {/* )} */}

                  
      </div>
    </>
  );
};

export default SearchFilter;
